@if (detailModel) {
    <div menuSystem [cerrixTab]="tab">
        <div [attr.name]="'Processed Document'" menuicon="fas fa-microchip-ai" menusystemsubmenu>
            <div name="Details" menuicon="fas fa-info-circle" menusystemitem>
                <div class="detail-page-card">
                    <div class="detail-page-card-title">{{ detailModel.title }}</div>
                    @for (chunk of detailModel.chunks; track chunk.id; let i = $index) {
                    <div class="detail-page-card-body padded form-group-styling">
                        <cerrix-collapsing-box [boxTitle]="'Chunk ' + (i + 1)">
                            <ng-template #content>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Content</label>
                                            <textarea
                                                class="form-control"
                                                rows="5"
                                                [value]="chunk.content"
                                                readonly
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </cerrix-collapsing-box>
                    </div>
                    }
                </div>
            </div>
            <div name="Options" menuicon="fas fa-check-double" menusystemitem>
                <detail-options
                    moduleName="processed document"
                    [objectName]="detailModel.title"
                    [allowDelete]="true"
                    (onDelete)="delete()"
                >
                </detail-options>
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
